import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
    ButtonModule,
    CheckboxModule,
    FileDropModule,
    InputModule,
    RadioModule,
    SelectModule,
    TextareaModule
} from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrderEntryInternationalFormGroup } from '../../../models/cod-create.model';
import { AccountErrorType } from '@cod-monorepo/interfaces';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { OrderEntryIssueTypeInternational } from '@cod-monorepo/interfaces';
import { Store } from '@ngxs/store';
import { AddCurrentCodLine } from '../../../state/cod.action';
import { BaseInternationalStep } from '../base-international-step/base-international-step';

@Component({
    selector: 'app-cod-order-entry-international-step',
    templateUrl: './order-entry-international.component.html',
    imports: [
        CommonModule,
        SelectModule,
        InputModule,
        FormsModule,
        ReactiveFormsModule,
        RadioModule,
        CheckboxModule,
        ButtonModule,
        FileDropModule,
        TextareaModule,
        AttachmentsInputComponent
    ],
    standalone: true
})
export class CodOrderEntryInternationalStepComponent extends BaseInternationalStep {
    @Input() orderEntryInternationalForm: FormGroup<OrderEntryInternationalFormGroup> | undefined;

    public orderEntryIssueTypes = OrderEntryIssueTypeInternational;
    public accountErrorTypes = AccountErrorType;

    constructor(private store: Store) {
        super();
    }

    public get showFinancialAdjustment(): boolean {
        const issueType = this.orderEntryInternationalForm?.controls.issueType.value;
        const accountErrorType = this.orderEntryInternationalForm?.controls.accountErrorType.value;
        const canIdentifyCartonId = this.orderEntryInternationalForm?.controls.canIdentifyCartonId.value;

        return Boolean(
            (issueType === OrderEntryIssueTypeInternational.WRONG_ACCOUNT_INT && accountErrorType) ||
                canIdentifyCartonId !== null
        );
    }

    public handleConfirm() {
        if (this.orderEntryInternationalForm?.valid) {
            this.store.dispatch(new AddCurrentCodLine());
        }
    }

    public isValid(): boolean {
        return this.orderEntryInternationalForm?.valid ?? false;
    }
}
